<template>

</template>

<script>
export default {
  data(){
    return {
      flag: false,  //代表播放和暂停,false代表目前是暂停状态
    }
  },
  created(){
    
  },
  methods: {
    play() {

    },
  }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}
.box,.line {
    height: 10px;
}
.box {
    width: 200px;
    margin: 0 auto;
    border: 1px solid #000;
    margin-top: 100px;
}
.line {
    width: 0;
    background: #f00;
}
</style>
